export default "__VITE_ASSET__P0JwxahC__"